import { createBrowserHistory } from 'history';
import api from './api';

const history = createBrowserHistory();

const setupInterceptors = () => {
    // Request interceptor to include the bearer token
    api.interceptors.request.use(config => {
        const token = localStorage.getItem('Token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            if (history.location.pathname !== '/login') {
                history.push('/login');
                window.location.reload(); // Ensure the redirect takes effect
            }
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });

    // Response interceptor to handle specific status codes
    api.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response.status === 401) {
            if (history.location.pathname !== '/login') {
                history.push('/login');
                window.location.reload(); // Ensure the redirect takes effect
            }
        }
        return Promise.reject(error);
    });
};

export default setupInterceptors;
